import { render, staticRenderFns } from "./PendenciaApuracao.vue?vue&type=template&id=3dd482c4&"
import script from "./PendenciaApuracao.vue?vue&type=script&lang=js&"
export * from "./PendenciaApuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/PendenciaApuracao.vue
// module id = 108
// module chunks = 28